import React from 'react';

import { Header, Navbar } from '@C';
import { RouteSetup } from '@C/DataBackUp';
import ErrorBoundary from '@C/Error';

const DataBackUp = () => {
  return (
    <main>
      <div className="page-wrapper">
        <Header title="Data Backup" />
        <Navbar />
        <div className="page-content">
          <section className="page-components">
            <div className="page-title">
              <h1> Data Backup</h1>
            </div>
            <ErrorBoundary>
              <RouteSetup />
            </ErrorBoundary>
          </section>
        </div>
      </div>
    </main>
  );
};

export { DataBackUp };
